@import "../fonts.css";

div.loading-wrapper {
	display: flex;
	width: 100%;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	overflow: hidden;
}

div.no-results {
	padding: 80px 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 30px;
}

.no-results-img {
	width: min(215px, 80%);
}

.no-results-text {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 15px;
	max-width: 68ch;
}

.no-results-title {
	text-align: center;
	font-size: 20px;
	font-weight: bold;
	color: black;
	margin: 0;
}

p.no-results-p {
	text-align: center;
	font-size: 15px;
	font-weight: 400;
	color: black;
	margin: 0;
	text-wrap: balance;
}

.pagination-wrapper {
	max-width: 100%;
	margin-top: 1rem;
	display: flex;
	justify-content: center;
	position: relative;
}
